import styled from '@emotion/styled'

import { Button, spacing } from 'main/ui'

export const StyledButton = styled(Button)`
  margin-top: ${spacing.majorScale(3)}px;
`
export const ChooseContainer = styled.div`
  margin-top: ${spacing.majorScale(4)}px;
`
